import React, { createContext, useContext, useMemo, useState } from 'react';

const defaultDetails = {
  applicationCode: null,
  paymentMethodDTO: null,
  userSubscription: null,
  userSubscriptionBenefitsDTO: null,
  userSubscriptionDevicesList: null,
};

const defaultSimPluginType = {
  up0405: false,
  up1011: false,
};

const defaultSubscriptionPlansData = {
  prices: [],
  userSubscriptionPlanFeaturesDTOList: [],
};

const SubscriptionContext = createContext(null);

export const SubscriptionProvider = ({ children }) => {
  const [details, setDetails] = useState(defaultDetails);
  const [loading, setLoading] = useState(true);
  const [simPluginType, setSimPluginType] = useState(defaultSimPluginType);
  const [subscriptionPlansData, setSubscriptionPlansData] = useState(defaultSubscriptionPlansData);
  const [planReturnTab, setPlanReturnTab] = useState(null);
  // 地区权威状态：RegionGate 守卫首跳写入。v5paySub = 持有进行中 V5Pay 订阅 ⇒ 俄区界面
  const [regionChecked, setRegionChecked] = useState(false);
  const [countryCode, setCountryCode] = useState('');
  const [v5paySub, setV5paySub] = useState(false);
  const isRU = countryCode === 'RU' || v5paySub;

  const value = useMemo(
    () => ({
      details,
      setDetails,
      loading,
      setLoading,
      simPluginType,
      setSimPluginType,
      subscriptionPlansData,
      setSubscriptionPlansData,
      planReturnTab,
      setPlanReturnTab,
      regionChecked,
      setRegionChecked,
      countryCode,
      setCountryCode,
      v5paySub,
      setV5paySub,
      isRU,
    }),
    [details, loading, simPluginType, subscriptionPlansData, planReturnTab, regionChecked, countryCode, v5paySub],
  );

  return <SubscriptionContext.Provider value={value}>{children}</SubscriptionContext.Provider>;
};

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within SubscriptionProvider');
  }
  return context;
};
